$(document).ready(
    function () {

        let p = $("body").attr("p");
        let a = $("body").attr("a");
        if (p === 'organizer_booking_area' && a === 'list') {

            $(document).on("click", ".booking-area-delete-button", function () {
                let bookingAreaId = $(this).attr('data-booking-area-id');
                let locationId = $("body").attr("event_id");
                let confirmMessage = $(this).attr("data-delete-message");
                if (!confirm(confirmMessage)) {
                    return false;
                }
                if (parseInt($(this).attr("data-number-of-tables-in-booking-area")) > 0) {
                    return false;
                }

                $.ajax({
                    type: 'POST',
                    url: "/ajax/organizer_booking_area/delete",
                    data: {
                        booking_area_id: bookingAreaId,
                        location_id: locationId
                    }
                })
                    .done(function (data) {

                        if (data.html !== undefined && data.html !== null) {
                            $('#booking-area-list-sortable').empty();
                            $('#booking-area-list-sortable').append(data.html);
                            popupAlert();
                        }


                    })
                    .fail(function (data) {

                        if (data.responseJSON.redirect_url !== undefined && data.responseJSON.redirect_url !== null) {
                            document.location.href = data.responseJSON.redirect_url;
                        }

                    })

            });

        }

    }
);